<template>
	<div>
		<div id="fund-facts-body">
			<h3 class="module-title">
				Fund Facts
			</h3>
			<div class="row">
				<div class="col-md-6">
					<div v-for="(item, index) in fundFactsData.leftData" :key="index">
						<div class="data-row">
							<span>
								{{ item.label }}
								<disclosure-superscript
									v-if="item.label === 'Regular Dividends Paid'"
									class="detail-page"
									anchor="fundFacts_regDividend"
									:statistics="['mthDividendsPaid']"
								/>
							</span>
							<span class="data">{{ item.data }}</span>
							<div v-if="item.asOfDate" class="sub-info">
								{{ item.asOfDate }}
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div v-for="(item, index) in fundFactsData.rightData" :key="index">
						<div class="data-row">
							<span>
								{{ item.label }}
								<disclosure-superscript
									v-if="item.label === 'Capital Gains Paid'"
									class="detail-page"
									anchor="fundFacts_capGains"
									:statistics="['mthCapitalGainsPaid']"
								/>
							</span>
							<span class="data">{{ item.data }}</span>
							<div v-if="item.asOfDate" class="sub-info">
								{{ item.asOfDate }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: 'FundFact',
	computed: {
		...mapGetters([
			'getFundFacts',
			'getFundAttributes',
			'isAFISTargetDate'
		]),
		fundFactsData() {
			let data = {
				leftData: [],
				rightData: []
			};
			if (this.getFundFacts) {
				data = {
					leftData: [
						this.getFundFacts.InceptionDate,
						this.getFundFacts.FundAssetsMillions,
						this.getFundFacts.TotalHoldingsCount,
						this.getFundFacts.DividendDistributionFrequency
					],
					rightData: [
						this.getFundFacts.CapitalGainDistributionFrequency,
						this.getFundFacts.PortfolioTurnover,
						this.getFundFacts.FiscalMonth,
						this.getFundFacts.ProspectusDate,
						this.getFundFacts.CUSIP,
						this.getFundFacts.FundClassNumber
					]
				};
				// exclude rows for specific funds
				const filterData = dataFilter => {
					if (dataFilter) {
						data.leftData = data.leftData.filter(
							item => !dataFilter.includes(item)
						);
						data.rightData = data.rightData.filter(
							item => !dataFilter.includes(item)
						);
					}
				};
				// exclusions
				const fundDataRowExclusions = fundSymbol => {
					if (
						fundSymbol &&
						fundSymbol.toLowerCase().includes('viubf')
					) {
						return [
							this.getFundFacts.TotalHoldingsCount,
							this.getFundFacts.PortfolioTurnover
						];
					}
					return false;
				};
				const objectiveDataRowExclusions = objective => {
					if (this.isAFISTargetDate) {
						return [this.getFundFacts.TotalHoldingsCount];
					}
					return false;
				};
				const filterByFund = fundDataRowExclusions(
					this.getFundAttributes &&
					this.getFundAttributes.FundSymbol &&
					this.getFundAttributes.FundSymbol.toLowerCase()
				);
				const filterByObjective = objectiveDataRowExclusions(
					this.getFundAttributes &&
					this.getFundAttributes.Objective &&
					this.getFundAttributes.Objective.toLowerCase()
				);
				filterData(filterByFund);
				filterData(filterByObjective);
				// pass data to event bus
				this.$EventBus.$emit('ExcelData', 'FundFactsModule', data);
			}
			return data;
		}
	}
};
</script>

<style lang="less" scoped>
@import '~_css_/variables';

#fund-facts-body {
	.module-border-top();
	font-family: "AvenirNextLTW01-Regular";
	font-size: 14px;
	margin-bottom: 40px;

	.data {
		color: @dark-gray;
		float: right;
	}

	.data-row {
		.thin-light-gray-border-bottom();
		color: @gray;
		padding: 5px 0px;
	}

	.sub-info {
		margin-top: 5px;
		font-size: 11px;
	}
}
</style>
